import { createReducer } from '@reduxjs/toolkit';
import { FluxAction } from '@saucelabs/sl-util-redux';

import types from './types';
import * as globalTypes from '../../types';

type ImageInjectionState = {
  readonly fileName: string;
  readonly isLoading: boolean;
  readonly previewImageURL: string;
}

const initialState: ImageInjectionState = {
  fileName: '',
  isLoading: false,
  previewImageURL: '',
};

const imageInjectionReducer = createReducer(initialState, (builder) => {
  builder.addCase(types.MOBILE_DEVICE_INJECT_IMAGE.REQUEST, (draft) => {
    draft.isLoading = true;
  });

  // explicitly cast the action to FluxAction to be able to access "meta"
  // since actions/operations are not typed yet
  builder.addCase<string, FluxAction>(types.MOBILE_DEVICE_INJECT_IMAGE.SUCCESS,
    (draft, { meta }) => {
      draft.isLoading = false;
      draft.fileName = meta.fileName;
      draft.previewImageURL = meta.previewImageURL;
    },
  );

  builder.addCase(types.MOBILE_DEVICE_INJECT_IMAGE.FAILURE, (draft) => {
    draft.isLoading = false;
  });

  builder.addCase(globalTypes.MOBILE_SESSION_STOP.SUCCESS, () => initialState);
});

export default imageInjectionReducer;
export {
  ImageInjectionState,
  initialState,
};
